import moment from 'moment'
import { currentLanguage } from '../../i18n/current'
import { formatDate } from '../../i18n/format'

/**
 * Submission dates on the corrections page. English keeps the day-first order the page has
 * always shown ("05 Oct 2026", "1 Sep"), which Intl's English does not produce; every other
 * language gets its own order from Intl (format.ts).
 */
export const formatCorrectionDate = (timestamp: number): string =>
  currentLanguage() === 'en'
    ? moment(timestamp).format('DD MMM YYYY')
    : formatDate(timestamp, { day: '2-digit', month: 'short', year: 'numeric' })

/** Day and month only: "1 Sep" in English. */
export const formatCorrectionDayMonth = (timestamp: number): string =>
  currentLanguage() === 'en' ? moment(timestamp).format('D MMM') : formatDate(timestamp, 'monthDay')
